
	<header class="article-header" [class.playing]="(activeScreen$ | push).length === 0" >
		<span class="header-text" [ngClass]="article.field_logo_1 ? 'header-has-logo' : ''">
			<h1 class="title">{{article.title || article.entityLabel}}</h1>
			<span>
				<span  [ngClass]="article.field_logo_1 ? 'logo' : 'no-logo'" class="partner-icon">
					<app-card-logo class="detail-thumbnail logo" [article]="article" ></app-card-logo>
				</span>
				<h2 class="sub-title" *ngIf="article.field_sub_title || article.fieldSubtitle" >{{ article.field_sub_title || article.fieldSubtitle }}</h2>
				<h3 class="short-description" *ngIf="article.fieldShortDescription || article.field_short_description" >{{article.fieldShortDescription || article.field_short_description}}</h3>
			</span>
		</span>		
	</header>

	<div class="article-wrapper">
		<div class="content" [innerHtml]="article.body" ></div>
		<div class="external-link-wrapper" *ngIf="article.fieldExternalLink" >
			<a 	
				class="external-link link" 
				title="{{'otevřít stránky ' + article.fieldExternalLink.title + ' v novém okně'}}" 
				href="{{article.fieldExternalLink.url.path}}"
				target="_blank"
				matRipple
			>
				<span class="label">{{article.fieldExternalLink.title}}</span>
			</a>
		</div>
		<app-video-card class="video-card" [article]="article" ></app-video-card>
	</div>
<app-chips class="tags-container" [chips]="article.chips || article.fieldTags"></app-chips>
